export default __webpack_public_path__ + "static/caption-03-en-86d853f811eca614742837a119e12690.webp";